import typography from './typography';
import grid from './grid';
import layers from './layers';
import spacing from './spacing';
import buttons from './components/buttons';
import form from './components/form';
import icons from './components/icons';
import input from './components/input';
import messages from './components/messages';
import social from './components/social';
var components = {
  buttons: buttons,
  form: form,
  icons: icons,
  input: input,
  messages: messages,
  social: social
};
export default {
  typography: typography,
  grid: grid,
  layers: layers,
  spacing: spacing,
  components: components
};